/**
 * @hidden
 */
export var messages = Object.create({});
//# sourceMappingURL=messages.js.map